<template>
  <a href="#" class="UIAccordionToggle" @click="$emit('toggle')">
    <slot />
    <UIIcon
      :class="[
        'UIAccordionToggle__icon',
        {
          'UIAccordionToggle__icon--is-open': isOpen,
        },
      ]"
      name="chevronDown"
    />
  </a>
</template>

<script lang="ts" setup>
import UIIcon from '../icons/UIIcon.vue'

defineEmits(['toggle'])
defineProps<{
  isOpen?: boolean
}>()
</script>

<style scoped lang="scss">
.UIAccordionToggle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  cursor: pointer;
  color: $color-neutral-140;
  text-decoration: none;
  padding-right: 0.625rem;

  .UIAccordionToggle__icon {
    @include trans(0.1s);

    &--is-open {
      transform: rotate(180deg);
    }
  }
}
</style>
